import NavigationController from "../controller/NavigationController";
import UrlController from "../controller/UrlController";
import Renderer from "../Renderer";
import Utils from "../utils/Utils";

export default class OnlineController {
    constructor(fc) {
        this.fc = fc;
        this.urlListener = true;
        if (window._spreads == undefined) {
            window._spreads = [];
        }
    }

    init() {
        const dataHelper = this.fc.getDataHelper();
        dataHelper.once(dataHelper.READY, () => {
            this._dataReady();
        });

        dataHelper.on(dataHelper.ERROR, function () {
            NavigationController.pushState({}, "ERROR", "/" + window.abbr + "/" + dataHelper._error);
            return false;
        });

        dataHelper.getIssuesSpreads();
        // dataHelper._spreadRotate();
    }

    _dataReady() {
        if (Utils.hasHashBinding()) {
            const IDS = window._first || {};
            const hash = Utils.getLocationHash();

            if (!isNaN(hash)) {
                IDS.spread_id = hash;
            }

            if (IDS.spread_id) {
                const spreads = this.fc.getDataHelper().filterAndOrderSpreads(IDS.issue_id);
                this.fc.setCurrentIssueId(IDS.issue_id);

                //if the preloaded spread isn't in the current spreads list set the spread_id to the first of the available list.
                if (!spreads.find((spread) => spread.spread_id === IDS.spread_id)) {
                    IDS.spread_id = spreads[0].spread_id;
                }
                this.fc.setCurrentSpreadId(IDS.spread_id);
            }

            if (this.fc.mainStage.children.length > 0) {
                this.fc.createSpreadOrder();
                this.fc.interface.rendeSidePanelByIssueId(IDS.issue_id);
            } else {
                this._renderSpreads();
            }
            this.fc.interface.setPageNumber();
            if (IDS.spread_id) {
                this.fc.moveSpreadToMainStage(IDS.spread_id);
            }
            Utils.setLocationHash(IDS.spread_id);

            this.setUrlListener(false);
            this.fetchSpreadSettings(IDS.spread_id);
            this.fc.setSpreadId(IDS.issue_id, IDS.spread_id);
            this.fc.fetchSpread(IDS.spread_id);
            this.fc._urlChanged();
        } else {
            this.urlController = new UrlController(this.fc);
            this.urlController.bindUrlListener();
        }
    }

    setUrlListener(bool) {
        this.urlListener = bool;
    }
    hasUrlListener() {
        return this.urlListener;
    }

    fetchInlineSpreadSettings(client_id, issue_id, spread_id) {
        if (Utils.isEmpty(issue_id) && Utils.isEmpty(spread_id)) {
            return false;
        }
        const spread = this.fc.dataHelper.getSpreadById(issue_id, spread_id) || {};
        const settingsFilename =
            window.previewMode && spread.date_preview_published > spread.date_published
                ? `preview_spread.js?t=${spread.date_preview_published}`
                : `spread_settings_html.json?t=${spread.date_published}`;
        const url = `${window.data_domain}/${client_id}/issues/${issue_id}/${spread_id}/${settingsFilename}`;

        this.fc.createSpreadContainer(spread_id);

        if (window._spreads[spread_id]) {
            this.fc.initSpread(spread_id, window._spreads[spread_id]);
            this.fc.setSpreadStatus(spread_id, this.fc.SPREADSTATUSLIST.INIT);
        } else {
            Utils.AjaxPromise({
                url,
                dataType: "text", //text because we don't send valid json
            })
                .then(
                    (data) => {
                        window._spreads[spread_id] = eval(data); //eval because we want valid data without 'var'
                        this.fc.initSpread(spread_id, window._spreads[spread_id]);
                    },
                    () => {},
                )
                .catch((error) => {
                    console.error("MAGLR ERROR: [fetchInlineSpreadSettings]", error);
                });
        }
    }

    resetSpreads() {
        try {
            this.fc.advancedController.resetSpreads();
        } catch {
            // continue regardless of error
        }
        try {
            this.fc.iframeController.resetSpreads();
        } catch {
            // continue regardless of error
        }
    }

    checkInlinePossible(spread_id, issueId) {
        const inline_spreads = this.fc.getDataHelper().inline_spreads;
        if (inline_spreads.indexOf(spread_id) > -1) {
            return true;
        }
        if (this.fc.getSpreadType(spread_id, issueId) === 2 && this.fc.getSpreadAssetsVersion(spread_id, issueId) > 9) {
            inline_spreads.push(spread_id);
            return true;
        }
        return false;
    }

    fetchSpreadSettings(spread_id, init, immediately) {
        if (init) {
            this._renderSpreads();
        }
        this.fc.fetchSpreadProxy(spread_id, immediately);
    }

    /**
     * Renders the spreads from given issue with handlebars
     *
     * @private
     */
    _renderSpreads() {
        const dataHelper = this.fc.getDataHelper();
        const issue_id = this.fc.getCurrentIssueId();
        this.fc.interface.rendeSidePanelByIssueId(issue_id);
        this.fc.createSpreadOrder();

        const renderData = { spreads: dataHelper.filterAndOrderSpreads(issue_id), DATA_URL: window.data_domain };
        try {
            Renderer.registerPartial("spreadTemplate", document.getElementById("HB-spread").innerHTML);
        } catch (error) {
            console.error("MAGLR ERROR: [online.renderSpreads]", error);
        }

        //handlebars
        const source = this._getSpreadsHBTemplate();
        const output = Renderer.renderSource(source, renderData);
        Renderer.nativeInject("content-loader", output);
    }

    _getSpreadsHBTemplate() {
        if (!this._spreadsTemplate) {
            this._spreadsTemplate = $("#HB-preload-spreads").html();
        }
        return this._spreadsTemplate;
    }
}
